export default __webpack_public_path__ + "static/media/brands_black.6605cdaf.svg";